


<app-header-title>
  <span title>{{'employeeduration.title'|translate}}</span>
</app-header-title>
<div class="publicsetting"  style="padding: 0rem 3rem;">
    <dx-data-grid #grid class="dx-card wide-card" 
      [dataSource]="customDataSource"
      [showBorders]="false"
      [focusedRowEnabled]="true"
      [focusedRowIndex]="0"
     [allowColumnResizing]="true"
  [columnAutoWidth]="true"
      [columnHidingEnabled]="true"
      [showColumnLines]="false"
      [rowAlternationEnabled]="true"
      [showRowLines]="false"
      [showBorders]="false"
      [errorRowEnabled]="false"
      [rtlEnabled]="currentLang=='ar'?true:false"
      (onInitNewRow)="edit_add_duration($event)"
      >
      <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
      <dxo-pager [visible]="true"></dxo-pager>
        <dxo-editing
        mode="popup"
        [useIcons]="false"
        [allowAdding]="true"
        [allowDeleting]="true"
        [allowUpdating]="false"
        [texts]="button"
        >
        <dxo-texts [addRow]="addrowfun('employeeduration.title')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>
   <dxo-paging  [pageSize]="10"> </dxo-paging>  <dxo-pager
    [visible]="true"
    allowedPageSizes="true"
    displayMode="full"
    [showPageSizeSelector]="true"
    [showInfo]="false"
    [showNavigationButtons]="true"
  >
  </dxo-pager>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
  
      <dxi-column 
        dataField="employeeId" caption="{{'employeeduration.employee'|translate}}">
        <dxo-lookup
        [dataSource]="employeedropdown"
        valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"        ></dxo-lookup>
      </dxi-column>

      <dxi-column type="buttons">
        <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
        <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
    </dxi-column>
    </dx-data-grid>
  </div>



